import { Fragment } from 'react';

type OpenGraphProps = {
  siteName?: string;
  title?: string;
  description?: string;
  type?: string;
  image?: string;
  url?: string;
  locale?: string;
};

function OpenGraph({
  title,
  description,
  image,
  url,
  siteName,
  type = 'article',
  locale = 'en_US',
}: OpenGraphProps) {
  return (
    <Fragment>
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      {siteName && <meta property="og:site_name" content={siteName} />}

      <meta property="og:type" content={type} />
      <meta property="og:locale" content={locale} />
    </Fragment>
  );
}

export default OpenGraph;
